export const lessonData = {
  1: {
    title: "Lesson 1: The Manuscript Readiness Audit",
    lesson_focus: "Assess your manuscript's true state and readiness for readers using the Manuscript Readiness Scorecard.",
    sections: [
      {
        header: "1. Watch or Read",
        content: "Begin by reviewing the Lesson 1 video or outline in your course portal. Reflect on how clarity builds confidence before correction."
      },
      {
        header: "2. Score Yourself",
        content: "Use the Scorecard to rate your manuscript in 5 key areas: Concept & Structure, Voice & Flow, Craft & Consistency, Message & Ministry Fit, and Production Prep.",
        fields: [
          {
            type: "number",
            label: "Final Readiness Score (0-50)",
            store_as: "lesson1_score"
          }
        ]
      },
      {
        header: "3. Interpret Your Score",
        content: "Based on your Final Readiness Score, here's where you stand in your publishing journey:",
        interpretation: {
          ranges: [
            {
              min: 0,
              max: 30,
              stage: "Draft Stage",
              focus: "focus on restructuring and clarity"
            },
            {
              min: 31,
              max: 40,
              stage: "Refinement Stage", 
              focus: "time for professional feedback"
            },
            {
              min: 41,
              max: 50,
              stage: "Final Prep Stage",
              focus: "get ready to publish"
            }
          ]
        }
      },
      {
        header: "4. Reflect",
        fields: [
          {
            type: "textarea",
            label: "What surprised you about your manuscript's current state?",
            store_as: "lesson1_reflection1"
          },
          {
            type: "textarea",
            label: "Where do you sense God refining you most through this process?",
            store_as: "lesson1_reflection2"
          }
        ]
      },
      {
        header: "5. Faithful Focus",
        content: "\"Lord, help me see my work clearly — not through pride or fear, but through Your eyes of purpose and possibility.\""
      }
    ]
  },
  2: {
    title: "Lesson 2: Editing for the Reader's Experience",
    lesson_focus: "Learn to edit with empathy — crafting a smooth, meaningful experience for your reader.",
    fields: [
      {
        type: "textarea",
        label: "What kind of reading experience do you want to create?",
        store_as: "lesson2_reflection1"
      },
      {
        type: "textarea",
        label: "What part of your writing currently disrupts that experience?",
        store_as: "lesson2_reflection2"
      }
    ],
    note: "Encourage reflection on reader immersion, tone, and trust."
  },
  3: {
    title: "Lesson 3: The Self-Editing System (Cycling vs. Rewriting)",
    lesson_focus: "Simplify your editing with the layered approach — structure → style → sentence.",
    fields: [
      {
        type: "textarea",
        label: "What editing stage are you currently in?",
        store_as: "lesson3_reflection1"
      },
      {
        type: "textarea",
        label: "What's one change you'll make to your editing rhythm this week?",
        store_as: "lesson3_reflection2"
      }
    ]
  },
  4: {
    title: "Lesson 4: Scene, Sentence, and Soul",
    lesson_focus: "Deepen your writing voice and refine your craft for clarity and purpose.",
    fields: [
      {
        type: "textarea",
        label: "Where does your writing flow feel most natural or Spirit-led?",
        store_as: "lesson4_reflection1"
      },
      {
        type: "textarea",
        label: "Where does it feel forced or unclear?",
        store_as: "lesson4_reflection2"
      }
    ]
  },
  5: {
    title: "Lesson 5: Publishing Pathways Simplified",
    lesson_focus: "Understand the major indie publishing options and discern which aligns with your goals.",
    fields: [
      {
        type: "textarea",
        label: "Which publishing platform best suits your message and audience?",
        store_as: "lesson5_reflection1"
      },
      {
        type: "textarea",
        label: "What next step do you need to take toward publishing setup?",
        store_as: "lesson5_reflection2"
      }
    ]
  },
  6: {
    title: "Lesson 6: Book Setup Basics (Metadata & Files)",
    lesson_focus: "Get your book ready to upload with clarity and confidence.",
    fields: [
      {
        type: "textarea",
        label: "Have you clarified your book's title, subtitle, and keywords?",
        store_as: "lesson6_reflection1"
      },
      {
        type: "textarea",
        label: "What formatting or design task will you complete this week?",
        store_as: "lesson6_reflection2"
      }
    ]
  },
  7: {
    title: "Lesson 7: Your Simple Launch Plan",
    lesson_focus: "Plan a faith-centered, low-stress launch that serves your readers.",
    fields: [
      {
        type: "textarea",
        label: "What is your launch goal: connection, sales, or impact?",
        store_as: "lesson7_reflection1"
      },
      {
        type: "textarea",
        label: "List one peaceful, sustainable step you'll take to prepare for launch.",
        store_as: "lesson7_reflection2"
      }
    ]
  },
  8: {
    title: "Lesson 8: Stewarding Your Story Beyond Launch",
    lesson_focus: "Plan how to sustain your message and ministry beyond your book's release.",
    fields: [
      {
        type: "textarea",
        label: "How will you define success in faithful, gospel-centered terms?",
        store_as: "lesson8_reflection1"
      },
      {
        type: "textarea",
        label: "What's next for you as a GospelWise author in 2026?",
        store_as: "lesson8_reflection2"
      }
    ]
  }
};